import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const aboutUsSlice = createSlice({
  name: "aboutUs",
  initialState: {
    vision: {
      data: [],
      loading: false,
      error: null,
    },
    council: {
      data: [],
      loading: false,
      error: null,
    },
    managment: {
      data: [],
      loading: false,
      error: null,
    },
    studies: {
      data: [],
      loading: false,
      error: null,
    },
    leadership: {
      data: [],
      loading: false,
      error: null,
    },
    history: {
      data: [],
      loading: false,
      error: null,
    },
  },
  reducers: {
    fetchVisionStart(state) {
      state.vision.loading = true;
      state.vision.error = null;
    },
    fetchVisionSuccess(state, action) {
      state.vision.loading = false;
      state.vision.data = action.payload;
    },
    fetchVisionFailure(state, action) {
      state.vision.loading = false;
      state.vision.error = action.payload;
    },

    fetchCouncilStart(state) {
      state.council.loading = true;
      state.council.error = null;
    },
    fetchCouncilSuccess(state, action) {
      state.council.loading = false;
      state.council.data = action.payload;
    },
    fetchCouncilFailure(state, action) {
      state.council.loading = false;
      state.council.error = action.payload;
    },

    fetchManagmentStart(state) {
      state.managment.loading = true;
      state.managment.error = null;
    },
    fetchManagmentSuccess(state, action) {
      state.managment.loading = false;
      state.managment.data = action.payload;
    },
    fetchManagmentFailure(state, action) {
      state.managment.loading = false;
      state.managment.error = action.payload;
    },
    fetchStudiesStart(state) {
      state.studies.loading = true;
      state.studies.loading = null;
    },
    fetchStudiesSuccess(state, action) {
      state.studies.loading = false;
      state.studies.data = action.payload;
    },
    fetchStudiesFailure(state, action) {
      state.studies.loading = false;
      state.studies.error = action.payload;
    },
    fetchLeadershipStart(state) {
      state.leadership.loading = true;
      state.leadership.loading = null;
    },
    fetchLeadershipSuccess(state, action) {
      state.leadership.loading = false;
      state.leadership.data = action.payload;
    },
    fetchSLeadershipFailure(state, action) {
      state.leadership.loading = false;
      state.leadership.error = action.payload;
    },
    fetchHistoryStart(state) {
      state.history.loading = true;
      state.history.error = null;
    },
    fetchHistorySuccess(state, action) {
      state.history.loading = false;
      state.history.data = action.payload;
    },
    fetchHistoryFailure(state, action) {
      state.history.loading = false;
      state.history.error = action.payload;
    },
  },
});

export const {
  fetchVisionStart,
  fetchVisionSuccess,
  fetchVisionFailure,
  fetchCouncilStart,
  fetchCouncilSuccess,
  fetchCouncilFailure,
  fetchManagmentStart,
  fetchManagmentSuccess,
  fetchManagmentFailure,
  fetchStudiesStart,
  fetchStudiesSuccess,
  fetchStudiesFailure,
  fetchLeadershipStart,
  fetchLeadershipSuccess,
  fetchLeadershipFailure,
  fetchHistoryStart,
  fetchHistorySuccess,
  fetchHistoryFailure
} = aboutUsSlice.actions;

export const fetchVisionData = () => async (dispatch) => {
  dispatch(fetchVisionStart());
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/homePage/aboutPage/getVision`
    );
    const data = response.data.data[0] || {}; // Default to empty object if no data

    dispatch(
      fetchVisionSuccess({
        vision: data.vision || "",
        mission: data.mission || "",
      })
    );
  } catch (error) {
    dispatch(fetchVisionFailure(error.message || "Something went wrong"));
  }
};

export const fetchCouncilData = () => async (dispatch) => {
  dispatch(fetchCouncilStart());
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/homePage/aboutPage/getAllBoardOfCouncil`
    );
    const data = response.data.data || []; // Defaults to empty array if no data
    dispatch(fetchCouncilSuccess(data));
  } catch (error) {
    dispatch(fetchCouncilFailure(error.message || "Something went wrong"));
  }
};

export const fetchManagmentData = () => async (dispatch) => {
  dispatch(fetchManagmentStart());
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/homePage/aboutPage/getAllBoardOfManagement`
    );
    const data = response.data.data || []; // Defaults to empty array if no data
    dispatch(fetchManagmentSuccess(data));
  } catch (error) {
    dispatch(fetchManagmentFailure(error.message || "Something went wrong"));
  }
};

export const fetchStudiesData = () => async (dispatch) => {
  dispatch(fetchStudiesStart());
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/homePage/aboutPage/getAllBoardOfStudies`
    );
    const data = response.data.data || []; // Defaults to empty array if no data
    dispatch(fetchStudiesSuccess(data));
  } catch (error) {
    dispatch(fetchStudiesFailure(error.message || "Something went wrong"));
  }
};

export const fetchLeadershipData = () => async (dispatch) => {
  dispatch(fetchLeadershipStart());
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/homePage/aboutPage/getLeadershipMessages`
    );
    const data = response.data.data || []; // Defaults to empty array if no data
    dispatch(fetchLeadershipSuccess(data));
  } catch (error) {
    dispatch(fetchLeadershipFailure(error.message || "Something went wrong"));
  }
};

export const fetchHistoryData = () => async (dispatch) => {
  dispatch(fetchHistoryStart());
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/homePage/aboutPage/getHistory`
    );
    const data = response.data.data[0] || {}; // Default to empty object if no data

    dispatch(
      fetchHistorySuccess({
        history: data.description || ""
      })
    );
  } catch (error) {
    dispatch(fetchHistoryFailure(error.message || "Something went wrong"));
  }
};

export default aboutUsSlice.reducer;
